import { Component } from '@angular/core';
import { LynxAuthService } from '../../../services/auth.service';
import { LynxUserService } from '../../../services/user.service';

@Component({
    selector: 'lynx-username',
    templateUrl: './username.component.html',
    styleUrls: ['./username.component.scss'],
    standalone: false
})
export class UsernameComponent {
  constructor(
    private userService: LynxUserService,
    private authService: LynxAuthService
  ) {}

  get userName() {
    return this.userService.userName;
  }
}
